<div class="card">
  <div class="card-header card-no-border">
    <div class="header-top gap-1">
      <h5>{{ 'Sell Coins' | translate }}</h5>
      <div class="dropdown icon-dropdown">
        <button class="btn dropdown-toggle" type="button" (click)="toggle()"><i class="icon-more-alt"></i></button>
        <div class="dropdown-menu dropdown-menu-end" [class.show]="show"><a class="dropdown-item" href="#">{{ 'Weekly' | translate }}</a><a class="dropdown-item" href="#">{{ 'Monthly' | translate }}</a><a class="dropdown-item" href="#">{{ 'Yearly' | translate }}</a></div>
      </div>
    </div>
  </div>
  <div class="card-body pt-0">
    <form class="theme-form crypto-form">
      <div class="mb-3">
        <label class="form-label f-light" for="crypto-coin">{{ 'Enter Crypto Coins' | translate }}</label>
        <div class="position-relative">
          <input class="form-control" id="crypto-coin" type="number" placeholder="100" />
          <select class="form-select crypto-select warning">
            <option>{{ 'USD' | translate }}</option>
            <option>{{ 'BTC' | translate }}</option>
            <option>{{ 'LTC' | translate }}</option>
            <option>{{ 'ETH' | translate }}</option>
          </select>
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label f-light" for="bitcoin">{{ 'Enter Money Converted to' | translate }}</label>
        <div class="position-relative">
          <input class="form-control" id="bitcoin" type="number" placeholder="0.0043" />
          <select class="form-select crypto-select primary">
            <option>{{ 'LTC' | translate }}</option>
            <option>{{ 'USD' | translate }}</option>
            <option>{{ 'BTC' | translate }}</option>
            <option>{{ 'ETH' | translate }}</option>
          </select>
        </div>
      </div>
      <button class="btn btn-primary btn-hover-effect w-100" type="button">{{ 'Sell Coins' | translate }}</button>
    </form>
  </div>
</div>
